import React, { Component } from 'react'
import TransitionGroup from 'react-transition-group/TransitionGroup'
import CSSTransition from 'react-transition-group/CSSTransition'

import cn from 'classnames'
import s from './InputMessage.scss'

export default class InputMessage extends Component {
  static propTypes = {}
  render() {
    const { error, warning } = this.props
    const show = warning || error

    return (
      <TransitionGroup className={cn(s.container, 'input-message')}>
        {show && (
          <CSSTransition
            key="message"
            timeout={200}
            classNames={{
              enter: s.fadeEnter,
              enterActive: s.fadeEnterActive,
              appear: s.fadeEnter,
              appearActive: s.fadeEnterActive,
              exit: s.fadeExit,
              exitActive: s.fadeExitActive,
            }}
          >
            <div
              className={cn(s.message, { [s.error]: error })}
              dangerouslySetInnerHTML={{ __html: error || warning }}
            />
          </CSSTransition>
        )}
      </TransitionGroup>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Input/InputMessage/InputMessage.jsx